<template>
  <div class="apps">
    <v-expansion-panels v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-title class="apps-title">
          HIS Applications
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <div class="apps-content" v-if="apps.length > 0">
            <div v-for="app in apps" :key="app.id"
              class="single-marketing-app d-flex flex-column flex-sm-row justify-space-between align-center">
              <div class="name-image d-flex align-center ga-4">
                <img width="40px" height="40px" src="@/assets/images/facebook.svg" :alt="app.name" />
                <div class="name-desc d-flex flex-column ga-2">
                  <div class="name">{{ app.name }}</div>
                  <span class="desc" v-html="getDescriptionWithBoldName(app)"></span>
                </div>
              </div>
              <div class="action d-flex align-center ga-3">
                <!-- <div @click="goToInsights(app.id)" class="insights">
                  <svg
                    width="22"
                    height="21"
                    viewBox="0 0 22 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.1304 5.21825H21.9999V20.5833H19.1304V5.21825Z"
                      fill="#237276"
                    />
                    <path
                      d="M14.3479 10.0199H17.2175V20.5834H14.3479V10.0199Z"
                      fill="#237276"
                    />
                    <path
                      d="M0 10.9802H2.86957V20.5834H0V10.9802Z"
                      fill="#237276"
                    />
                    <path
                      d="M9.56519 11.9405H12.4348V20.5834H9.56519V11.9405Z"
                      fill="#237276"
                    />
                    <path
                      d="M4.78259 8.09927H7.65216V20.5834H4.78259V8.09927Z"
                      fill="#237276"
                    />
                    <path
                      d="M22 1.85715C22 2.23919 21.8488 2.60558 21.5798 2.87572C21.3107 3.14586 20.9457 3.29762 20.5652 3.29762C20.352 3.29644 20.1415 3.24894 19.9483 3.15838L17.0787 6.03933C17.1741 6.23153 17.2216 6.44405 17.2174 6.65874C17.2174 7.04077 17.0662 7.40716 16.7972 7.67731C16.5281 7.94745 16.1631 8.09921 15.7826 8.09921C15.5796 8.10016 15.3787 8.05784 15.1932 7.97507C15.0077 7.8923 14.8418 7.77096 14.7065 7.61905L12.4348 8.52655C12.4374 8.54406 12.4374 8.56186 12.4348 8.57937C12.4348 8.96141 12.2836 9.3278 12.0145 9.59794C11.7455 9.86808 11.3805 10.0198 11 10.0198C10.6195 10.0198 10.2545 9.86808 9.98546 9.59794C9.71638 9.3278 9.56522 8.96141 9.56522 8.57937C9.56431 8.41579 9.59182 8.2533 9.64652 8.09921L6.97304 5.9529C6.74709 6.09749 6.48532 6.17567 6.21739 6.17858C5.84739 6.18014 5.49168 6.03523 5.22739 5.77524L2.86957 6.96604C2.87429 7.02356 2.87429 7.08137 2.86957 7.13889C2.86977 7.471 2.75567 7.79298 2.54657 8.05032C2.33747 8.30766 2.04622 8.48456 1.72213 8.55107C1.39804 8.61759 1.06101 8.56962 0.768094 8.41531C0.47518 8.26099 0.244375 8.0098 0.114749 7.70425C-0.0148771 7.3987 -0.0353601 7.05757 0.0567668 6.73861C0.148894 6.41964 0.347971 6.14243 0.6203 5.9539C0.892628 5.76537 1.22148 5.67711 1.55118 5.70405C1.88089 5.731 2.19119 5.87149 2.42957 6.10175L4.78261 4.91576C4.77788 4.85663 4.77788 4.79722 4.78261 4.7381C4.78261 4.35606 4.93377 3.98967 5.20285 3.71953C5.47192 3.44939 5.83686 3.29762 6.21739 3.29762C6.59792 3.29762 6.96286 3.44939 7.23194 3.71953C7.50101 3.98967 7.65217 4.35606 7.65217 4.7381C7.65358 4.90172 7.62605 5.0643 7.57087 5.21826L10.2396 7.36457C10.4669 7.21912 10.7304 7.14091 11 7.13889C11.203 7.13795 11.4039 7.18026 11.5894 7.26303C11.7749 7.3458 11.9408 7.46715 12.0761 7.61905L14.3478 6.71635C14.3455 6.69722 14.3455 6.67787 14.3478 6.65874C14.3478 6.2767 14.499 5.91031 14.7681 5.64016C15.0371 5.37002 15.4021 5.21826 15.7826 5.21826C15.9964 5.21953 16.2072 5.26875 16.3996 5.36231L19.2691 2.48135C19.1769 2.28635 19.1295 2.07302 19.1304 1.85715C19.1304 1.47511 19.2816 1.10872 19.5507 0.838577C19.8197 0.568436 20.1847 0.416672 20.5652 0.416672C20.9457 0.416672 21.3107 0.568436 21.5798 0.838577C21.8488 1.10872 22 1.47511 22 1.85715Z"
                      fill="#237276"
                    />
                  </svg>
                </div> -->
                <div @click="addApp()" class="add">
                  <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14 2.83333C16.3074 2.83333 18.563 3.51757 20.4816 4.79952C22.4002 6.08147 23.8955 7.90355 24.7785 10.0354C25.6616 12.1672 25.8926 14.5129 25.4424 16.776C24.9923 19.0392 23.8811 21.118 22.2495 22.7496C20.6179 24.3812 18.5391 25.4923 16.276 25.9425C14.0129 26.3927 11.6671 26.1616 9.53531 25.2786C7.40351 24.3956 5.58143 22.9002 4.29948 20.9816C3.01753 19.0631 2.33329 16.8074 2.33329 14.5C2.33329 12.9679 2.63506 11.4508 3.22136 10.0354C3.80766 8.61989 4.66703 7.33377 5.75038 6.25042C6.83373 5.16707 8.11985 4.30771 9.53531 3.7214C10.9508 3.1351 12.4679 2.83333 14 2.83333ZM8.16662 15.6667H12.8333V20.3333C12.8333 20.6427 12.9562 20.9395 13.175 21.1583C13.3938 21.3771 13.6905 21.5 14 21.5C14.3094 21.5 14.6061 21.3771 14.8249 21.1583C15.0437 20.9395 15.1666 20.6427 15.1666 20.3333V15.6667H19.8333C20.1427 15.6667 20.4395 15.5437 20.6582 15.325C20.877 15.1062 21 14.8094 21 14.5C21 14.1906 20.877 13.8938 20.6582 13.675C20.4395 13.4562 20.1427 13.3333 19.8333 13.3333H15.1666V8.66666C15.1666 8.35724 15.0437 8.0605 14.8249 7.8417C14.6061 7.62291 14.3094 7.5 14 7.5C13.6905 7.5 13.3938 7.62291 13.175 7.8417C12.9562 8.0605 12.8333 8.35724 12.8333 8.66666V13.3333H8.16662C7.8572 13.3333 7.56046 13.4562 7.34166 13.675C7.12287 13.8938 6.99996 14.1906 6.99996 14.5C6.99996 14.8094 7.12287 15.1062 7.34166 15.325C7.56046 15.5437 7.8572 15.6667 8.16662 15.6667Z"
                      fill="#237276" />
                  </svg>
                </div>
                <div class="status">
                  <button :disabled="!$permissionsFor('integration').update"
                    :class="{ 'read-only': !$permissionsFor('integration').update }" @click="connectApp(app.id)"
                    title="Connect" v-if="app.status === 'active'" class="connect">
                    Connect
                  </button>
                  <button :disabled="!$permissionsFor('integration').update"
                    :class="{ 'read-only': !$permissionsFor('integration').update }" @click="disableApp(app.id)"
                    title="Disable" v-if="app.status === 'inactive'" class="disable">
                    Disable
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="apps-content">
            <div class="comming-soon">Coming soon. Stay tuned</div>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: "IntegrationsIndex",
  data() {
    return {
      panel: 0,
      apps: [],
    };
  },
  methods: {
    getDescriptionWithBoldName(app) {
      return app.description.replace(app.name, `<strong>${app.name}</strong>`);
    },

  },
};
</script>

<style>
.apps {
  margin-bottom: 35px;
}

.apps .v-expansion-panels {
  padding: 40px 24px 40px 24px;
  gap: 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
}

.apps-title {
  color: rgba(6, 19, 20, 1);
  font-size: 18px;
  font-weight: 700;
  line-height: 21.78px;
}

.apps-content {
  padding: 16px 30px;
}

.apps-content .single-marketing-app:not(:last-child) {
  border-bottom: solid 1px rgba(230, 230, 230, 1);
}

.name-image .name-desc .name {
  font-size: 14px;
  font-weight: 600;
  line-height: 15px;
  color: rgba(0, 0, 0, 1);
}

.name-image .name-desc .desc {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: rgba(83, 100, 113, 1);
}

.single-marketing-app {
  margin: 21px 0px;
  padding: 18px 0px;
}

.single-marketing-app .action .status button {
  width: 98px;
  height: 32px;
  border-radius: 8px;
}

.single-marketing-app .action .status .connect:hover {
  background: rgb(23, 72, 75);
}

.single-marketing-app .action .status .connect {
  background: rgba(35, 114, 118, 1);
  color: white;
}

.single-marketing-app .action .status .disable:hover {
  background: rgb(199, 199, 199);
}

.single-marketing-app .action .status .disable {
  background: rgba(230, 230, 230, 1);
  color: rgba(102, 102, 102, 1);
}

.action .insights,
.action .add {
  cursor: pointer;
}

.v-application__wrap {
  min-height: unset !important;
}

.comming-soon {
  width: 35%;
  height: 35px;
  background: rgba(240, 251, 252, 1);
  color: rgba(31, 102, 106, 1);
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
  align-content: center;
  padding: 0px 15px;
}
</style>
